import {
  jb_button_tertiary_css_default
} from "./chunk.IEVEL4WM.js";
import {
  e as e2
} from "./chunk.3XLWIJBS.js";
import {
  reset_css_default
} from "./chunk.LJHCRQCZ.js";
import {
  Linkable
} from "./chunk.534YP5ZJ.js";
import {
  o
} from "./chunk.DJ2G5F2M.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Initiable
} from "./chunk.6DHNIVN5.js";
import {
  ButtonElement
} from "./chunk.ALE4QRAM.js";
import {
  attachInterestEvents
} from "./chunk.AHMM4X2O.js";
import {
  A,
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  e,
  n,
  r
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/jb-button-tertiary/jb-button-tertiary.ts
var JbButtonTertiary = class extends Initiable(ButtonElement(Linkable(i))) {
  constructor() {
    super(...arguments);
    this._hovering = false;
  }
  async connectedCallback() {
    super.connectedCallback();
    await this.updateComplete;
    attachInterestEvents(this._activeElement);
  }
  _getAnimationName() {
    switch (this.arrowDirection) {
      case "up":
        return "move_up";
      case "right":
        return "move_right";
      case "down":
        return "move_down";
      default:
        return "move_right";
    }
  }
  render() {
    const classes = {
      inactive: this.inactive,
      inverted: this.inverted,
      hover: this.forceHover || this._hovering,
      [`${this.arrowDirection}`]: this.arrowDirection
    };
    return this.link?.href ? b`<a
          data-linkable
          part="action"
          class=${e2(classes)}
          @interest=${() => {
      this._hovering = true;
    }}
          @loseinterest=${() => {
      this._hovering = false;
    }}
        >
          <slot>${this.text ? o(this.text) : A}</slot>
          <jb-icon
            iconName="material:east"
            .commonAnimation=${this._getAnimationName()}
            class="${e2({ hover: this.forceHover || this._hovering })}"
          ></jb-icon>
        </a>` : b`<button
          ?disabled=${this.inactive}
          part="action"
          class=${e2(classes)}
          @interest=${() => {
      this._hovering = true;
    }}
          @loseinterest=${() => {
      this._hovering = false;
    }}
        >
          <slot>${this.text ? o(this.text) : A}</slot>
          <jb-icon
            iconName="material:east"
            .commonAnimation=${this._getAnimationName()}
            class="${e2({ hover: this.forceHover || this._hovering })}"
          ></jb-icon>
        </button>`;
  }
};
JbButtonTertiary.styles = [reset_css_default, jb_button_tertiary_css_default];
JbButtonTertiary.shadowRootOptions = { ...i.shadowRootOptions, delegatesFocus: true };
__decorateClass([
  n()
], JbButtonTertiary.prototype, "arrowDirection", 2);
__decorateClass([
  n({ type: Boolean })
], JbButtonTertiary.prototype, "forceHover", 2);
__decorateClass([
  n({ type: Boolean })
], JbButtonTertiary.prototype, "inactive", 2);
__decorateClass([
  n({ type: Boolean })
], JbButtonTertiary.prototype, "inverted", 2);
__decorateClass([
  n()
], JbButtonTertiary.prototype, "name", 2);
__decorateClass([
  n()
], JbButtonTertiary.prototype, "text", 2);
__decorateClass([
  e("a, button")
], JbButtonTertiary.prototype, "_activeElement", 2);
__decorateClass([
  r()
], JbButtonTertiary.prototype, "_hovering", 2);
JbButtonTertiary = __decorateClass([
  customElement("jb-button-tertiary")
], JbButtonTertiary);

export {
  JbButtonTertiary
};
